<script>
import { nextTick } from 'vue'

export default {
  name: 'MenuComponent',
  
  props: {
    userLanguage: {
      type: String,
      default: 'cz'
    },
    languageStrings: {
      type: Object,
      default: null
    },
    role: {
      type: Number,
      default: 0
    }
  },

  emits: ['selected-menu-item', 'search'],

  data() { 
      return {
          searchString: '',
          ordersActive: false,
          plannerActive: false
      }     
  },

  methods: {
    selectMenuItem(item) {
      if (item === 'orders') {
        this.plannerActive = false
        this.ordersActive = !this.ordersActive
      }
      if (item === 'planner') {
        this.ordersActive = false
        this.plannerActive = !this.plannerActive
      }

      this.$emit("selected-menu-item", item)
    },
    async search() {
      this.$emit("search", '')
      await nextTick()
      this.$emit("search", this.searchString)
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
          this.search()
      }
    }
  }
}
</script>


<template>
  <div class="menu">
    <div class="menu-ul-div">
      <ul>
        <li class="menu-hamburger">
          <span>
            <img src="@/assets/images/menu.svg" />
          </span>
        </li>

        <li>
          <span>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu001 != null ? languageStrings.ui.menu001 : 'Jazyk' }}</span>
          <ul>
            <li><span :class="userLanguage === 'en' ? 'li-selected' : ''" @click="selectMenuItem('lang-en')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu002 != null ? languageStrings.ui.menu002 : 'Angličtina' }}</span></li>
            <li><span :class="userLanguage === 'cz' ? 'li-selected' : ''" @click="selectMenuItem('lang-cs')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu003 != null ? languageStrings.ui.menu003 : 'Čeština' }}</span></li>
            <li><span :class="userLanguage === 'pl' ? 'li-selected' : ''" @click="selectMenuItem('lang-pl')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu012 != null ? languageStrings.ui.menu012 : 'Polština' }}</span></li>
          </ul>
        </li>
        <li v-if="role == 3 || role == 4">
          <span>{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu019 != null ? languageStrings.ui.menu019 : 'Administrace' }}</span>
          <ul>
            <li><span @click="selectMenuItem('administration-analyses')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu020 != null ? languageStrings.ui.menu020 : 'Analýzy' }}</span></li>
            <li><span @click="selectMenuItem('administration-regions')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu021 != null ? languageStrings.ui.menu021 : 'Regiony' }}</span></li>
            <li>
              <span @click="selectMenuItem('administration-sensors')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu022 != null ? languageStrings.ui.menu022 : 'Senzory' }}</span>              
              <ul>
                <li><span @click="selectMenuItem('administration-sensors-parameters')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu023 != null ? languageStrings.ui.menu023 : 'Parametry' }}</span></li>
                <li><span @click="selectMenuItem('administration-sensors-sensors')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu022 != null ? languageStrings.ui.menu022 : 'Senzory' }}</span></li>
              </ul>
            </li>
            <li><span @click="selectMenuItem('administration-users')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu024 != null ? languageStrings.ui.menu024 : 'Uživatelé' }}</span></li>
            <li><span @click="selectMenuItem('administration-oil-types')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu025 != null ? languageStrings.ui.menu025 : 'Typy olejů' }}</span></li>
            <li><span @click="selectMenuItem('administration-viscosity-classes')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu026 != null ? languageStrings.ui.menu026 : 'Viskozitní třídy' }}</span></li>
            <li v-if="role == 4"><span @click="selectMenuItem('administration-import-configuration')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu027 != null ? languageStrings.ui.menu027 : 'Import konfigurace' }}</span></li>
          </ul>
        </li>
        <li v-if="role >= 1 && role <= 4"><span @click="selectMenuItem('sample-registration')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu011 != null ? languageStrings.ui.menu011 : 'Registrace vzorku' }}</span></li>
        <li v-if="role == 3 || role == 4"><span @click="selectMenuItem('qr-codes')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu016 != null ? languageStrings.ui.menu016 : 'Generování QR kódů' }}</span></li>
        <li v-if="role == 3 || role == 4"><span @click="selectMenuItem('pricelist')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu013 != null ? languageStrings.ui.menu013 : 'Ceník' }}</span></li>
        <li v-if="role == 3 || role == 4" :class="ordersActive ? 'li-selected' : ''"><span @click="selectMenuItem('orders')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu015 != null ? languageStrings.ui.menu015 : 'Objednávky' }}</span></li>
        <!-- <li v-if="role > 1 && role <= 4" :class="plannerActive ? 'li-selected' : ''"><span @click="selectMenuItem('planner')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu017 != null ? languageStrings.ui.menu017 : 'Plánovač' }}</span></li> -->
        <li v-if="role > 1 && role <= 4"><span @click="selectMenuItem('file-import')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu014 != null ? languageStrings.ui.menu014 : 'Import souborů' }}</span></li>
        <li><span><a href="help.html" target="_blank">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu018 != null ? languageStrings.ui.menu018 : 'Nápověda' }}</a></span></li>
        <li><span @click="selectMenuItem('logout')">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu004 != null ? languageStrings.ui.menu004 : 'Odhlášení' }}</span></li>
      </ul>
    </div>
    
    <div class="search-box">
      <input type="text" v-model="searchString" @keydown="handleKeyDown" autocomplete="off" :placeholder="languageStrings != null && languageStrings.ui != null && languageStrings.ui.menu010 != null ? languageStrings.ui.menu010 : 'Hledat'" />
      <button class="button-strip" @click="search"><img src="@/assets/images/search.svg" /></button>      
    </div>

    <div class="logo">
      <img class="logo-big" src="@/assets/images/kleentek_logo.png" height="30px;" />
      <img class="logo-small" src="@/assets/images/kleentek_logo_small.png" height="30px;" />
    </div>
  </div>
</template>